import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  Pagination,
} from "react-bootstrap";
import {
  FiEdit, FiTrash2, FiPlus, FiFileText, FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getNotice, deleteNotice } from "../../store/slices/notice";
import { toast } from "react-hot-toast";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Notices() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const stripHtml = (html, maxLength = 80) => {
    if (!html) return "-";
    const text = html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
  };

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const fetchNotice = () => {
    setIsLoading(true);

    dispatch(getNotice())
      .unwrap()
      .then((res) => {
        const notices = res?.data || [];
        setData(notices);
        setTotalData(res?.totalDataCount || notices.length);
      })
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch Noticedetails ");
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchNotice();
  }, []);

  const navigateNoticedata = (id) => {
    navigate(`/institute/edit-notice/${id}`);
  };

  const handleDeleteRow = (id) => {
    if (!id) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Notice?",
    );
    if (!confirmDelete) return;

    dispatch(deleteNotice(id))
      .unwrap()
      .then(() => {
        toast.success("Noticedetails deleted successfully");
        fetchNotice();
      })
      .catch((err) => {
        toast.error(err || "Failed to delete");
      });
  };

  // total page
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

  return (
    <Container fluid>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <FiHome />
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/home">Home</Link>

            <FiChevronRight className="separator" />

            <span className="active">Notice</span>
          </div>

          <Link
            to="/institute/add-notice"
            className="add-btn"
          >
            <FiPlus />
            Add Notice
          </Link>

        </div>
      </div>

      <div className="staff-card">


        {/* Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">Date</th>
                <th className="text-center">Details</th>
                <th className="text-center">For</th>
                <th className="text-center">File</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                Array.from({ length: 8 }).map((_, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <Skeleton width={20} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={90} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={250} />
                    </td>

                    <td className="text-center">
                      <Skeleton width={80} />
                    </td>

                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        <Skeleton width={22} height={22} borderRadius={4} />
                        <Skeleton width={22} height={22} borderRadius={4} />
                      </div>
                    </td>

                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        <Skeleton width={36} height={36} borderRadius={10} />
                        <Skeleton width={36} height={36} borderRadius={10} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : paginatedData.length > 0 ? (
                paginatedData.map((s, i) => (
                  <tr key={s._id}>
                    <td className="text-center">
                      {startIndex + i + 1}
                    </td>

                    <td className="text-center">
                      {new Date(s.date).toLocaleDateString("en-GB")}
                    </td>

                    <td className="text-center">
                      {stripHtml(s.description)}
                    </td>

                    <td className="text-center">
                      {s.usertype === 1
                        ? "Student"
                        : s.usertype === 2
                          ? "Staff"
                          : s.usertype === 3
                            ? "All"
                            : "-"}
                    </td>

                    <td className="text-center">
                      {s.files?.length > 0 ? (
                        <div
                          className="d-flex justify-content-center gap-2 flex-wrap"
                        >
                          {s.files.map((file, index) => (
                            <FiFileText
                              key={index}
                              size={18}
                              title={`View file ${index + 1}`}
                              style={{
                                cursor: "pointer",
                                color: "#2563eb",
                              }}
                              onClick={() => window.open(file, "_blank")}
                            />
                          ))}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className="text-center">
                      <button
                        className="edit-btn"
                        onClick={() => navigateNoticedata(s._id)}
                      >
                        <FiEdit />
                      </button>

                      <button
                        className="edit-btn ms-2"
                        onClick={() => handleDeleteRow(s._id)}
                      >
                        <FiTrash2 />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-4"
                  >
                    No notices found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>
      </div>
    </Container>
  );
}
